<template>
    <div
        v-if="company?.review_rating"
        :class="[!match.isAnonymous ? '' : '']"
        class="flex w-fit items-center gap-0.5 rounded px-0.5"
    >
        <SvgIcon
            class="text-muval-amber h-3.5 w-3.5"
            name="system-star"
        />
        <div :class="match.isAnonymous ? 'text-muval-gray-1 text-sm font-medium' : 'text-muval-gray-3 text-xs'">
            <span class="leading-none">{{ company?.review_rating }}</span>
            <span class="text-muval-gray-3 leading-none"> ({{ company?.review_count }})</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { MoveMatch, Company } from '@/types';

interface Props {
    match: MoveMatch;
    company?: Company;
}

defineProps<Props>();
</script>
